import Faq from "../ico-landing/faq/Faq";
import Image from "next/image";
const Story = ({ compFor }) => {

    return (
      <div>
        <section className="relative -translate-y-12">
          <div className="container">
            <div className="lg:flex lg:justify-between">
              {/* <!-- Image --> */}
              <div className="lg:w-[45%] hidden lg:block">
                <div className="relative mt-12 mr-24">
                  <Image
                  alt="character3"
                    src="/images/products/character3.png"
                    width="400"
                    height="400"
                    className="mt-8 rotate-[8deg] rounded-[10rem]"
                  />
                </div>
              </div>

              {/* <!-- Info --> */}
              <div className="pt-8 lg:w-[55%] lg:pl-16">
                <h2 className="text-jacarta-700 font-display mb-6 text-2xl dark:text-white">
                  Frequently Asked Questions
                </h2>
                <Faq />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
};

export default Story;
